(() => {
  const config = window.GamaroCartGift;

  if (!config || !config.enabled || !config.variantId || !config.goal) return;

  const isFreeGiftVariant = Number(config.variantPrice) <= 0;
  if (!isFreeGiftVariant) return;

  const state = {
    syncing: false,
  };

  const fetchCart = () => fetch('/cart.js', {
    headers: {
      Accept: 'application/json',
    },
  }).then((response) => response.json());

  const postCart = (url, body) => fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(body),
  });

  const getGiftItem = (cart) => cart.items.find((item) => item.variant_id === config.variantId);

  const getEligibleTotal = (cart, giftItem) => {
    const subtotal = cart.items_subtotal_price ?? cart.original_total_price ?? cart.total_price;

    if (!giftItem) return subtotal;

    return Math.max(0, subtotal - (giftItem.original_line_price ?? giftItem.final_line_price ?? 0));
  };

  const reloadCart = (shouldReload) => {
    if (shouldReload) window.location.reload();
  };

  const syncGift = async ({ reload = true } = {}) => {
    if (state.syncing) return false;
    state.syncing = true;

    try {
      const cart = await fetchCart();
      const giftItem = getGiftItem(cart);
      const eligibleTotal = getEligibleTotal(cart, giftItem);
      const shouldHaveGift = eligibleTotal >= config.goal;

      if (shouldHaveGift && !giftItem) {
        await postCart('/cart/add.js', {
          items: [
            {
              id: config.variantId,
              quantity: 1,
              properties: {
                _gamaro_gift: 'true',
              },
            },
          ],
        });
        reloadCart(reload);
        state.syncing = false;
        return true;
      }

      if (shouldHaveGift && giftItem && giftItem.quantity !== 1) {
        await postCart('/cart/change.js', {
          id: giftItem.key,
          quantity: 1,
        });
        reloadCart(reload);
        state.syncing = false;
        return true;
      }

      if (!shouldHaveGift && giftItem) {
        await postCart('/cart/change.js', {
          id: giftItem.key,
          quantity: 0,
        });
        reloadCart(reload);
        state.syncing = false;
        return true;
      }
    } catch (error) {
      state.syncing = false;
      return false;
    }

    state.syncing = false;
    return false;
  };

  const scheduleSync = () => {
    window.setTimeout(syncGift, 160);
  };

  window.GamaroSyncCartGift = syncGift;

  window.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  window.addEventListener('pageshow', scheduleSync);
  document.addEventListener('cart:update', scheduleSync);
  document.addEventListener('cart:updated', scheduleSync);
  document.addEventListener('cart:refresh', scheduleSync);
  document.addEventListener('discount:update', scheduleSync);

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest(
      'a[href*="/cart"], a[href*="/checkout"], a.cart__checkout-button[href]'
    );
    if (!trigger || trigger.dataset.gamaroGiftSynced === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    await syncGift({ reload: false });

    trigger.dataset.gamaroGiftSynced = 'true';

    if (trigger.href) {
      window.location.href = trigger.href;
      return;
    }

    const form = trigger.closest('form');
    if (form) {
      form.requestSubmit ? form.requestSubmit(trigger) : form.submit();
    }
  }, true);
})();
